import React from 'react'
import { Container, Row, Col, Card, CardBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const AccessDenied = () => {
  const { t } = useTranslation()

  return (
    <div className='content'>
      <Container className='d-flex align-items-center justify-content-center vh-100'>
        <Row>
          <Col md='8'>
            <Card className='card-plain'>
              <CardBody>
                <div className='error-page text-center'>
                  <h1 className='error-title'>{t('accessDenied.title')}</h1>
                  <h4 className='error-subtitle'>{t('accessDenied.subtitle')}</h4>
                  <p className='error-text'>{t('accessDenied.text')}</p>
                  <a href='/' className='btn btn-primary'>
                    {t('accessDenied.goHome')}
                  </a>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AccessDenied
